import React from 'react';
import { Box } from '@mui/material';

import PostDescription from '../../../DesignSystem/PostDescription';
import PostLocation from '../../Shared/PostLocation';
import CommentsSection from '../../../Comments/Show';
import AttachmentLinksList from '../../Shared/AttachmentLinksList';

function MessagingPostShow({ post }: any) {
  const [lat, lng] = (post.latlng || '').split(',');

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <PostDescription content={post.content} />
        <AttachmentLinksList attachments={post.attachments} />
      </Box>

      <PostLocation label={post.location} lat={lat} lng={lng} status={post.status} />

      <CommentsSection post={post} />
    </Box>
  );
}

export default MessagingPostShow;
